import { Controller } from "@hotwired/stimulus"

// Вкладка «Этикетка»: показывает поля под слоты выбранного шаблона и держит
// кнопку заблокированной, пока не закрыты все причины (серверные приходят
// data-атрибутом опции, незаполненные поля контроллер считает сам).
export default class extends Controller {
  static targets = ["template", "field", "input", "submit", "notice"]

  connect() {
    this.updateState()
  }

  selectedOption() {
    const select = this.templateTarget
    return select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null
  }

  hasSlot(option, slot) {
    return option?.getAttribute(`data-has-${slot.replace(/_/g, "-")}`) === "true"
  }

  serverBlockers(option) {
    try {
      return JSON.parse(option?.getAttribute("data-blockers") || "[]")
    } catch (error) {
      return []
    }
  }

  updateState() {
    const option = this.selectedOption()
    const templateChosen = Boolean(this.templateTarget.value)
    const missing = []

    this.fieldTargets.forEach((field) => {
      const slot = field.dataset.slot
      const visible = templateChosen && this.hasSlot(option, slot)
      field.hidden = !visible

      const input = field.querySelector("input")
      if (!input) return

      input.disabled = !visible
      if (visible && !input.value.trim()) {
        missing.push(field.querySelector("label")?.textContent?.trim() || slot)
      }
    })

    const problems = templateChosen
      ? [...this.serverBlockers(option), ...missing.map((label) => `Не заполнено: ${label}`)]
      : ["Шаблон этикетки не выбран"]

    if (this.hasNoticeTarget) {
      this.noticeTarget.textContent = problems.join("; ")
    }
    this.submitTarget.disabled = problems.length > 0
  }

  async submit(event) {
    event.preventDefault()
    const form = event.target
    this.submitTarget.disabled = true

    try {
      const response = await fetch(form.action, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
          Accept: "application/json",
        },
        body: new FormData(form),
      })

      const payload = await response.json().catch(() => ({}))
      if (!response.ok || payload.success === false) {
        alert(payload.error || "Не удалось запустить генерацию этикетки")
        this.updateState()
      }
    } catch (error) {
      alert(error.message)
      this.updateState()
    }
  }
}
